/* eslint-disable @typescript-eslint/naming-convention */
import { selectAnatomy as parts } from '@chakra-ui/anatomy';
import type { SystemStyleObject, PartsStyleObject } from '@chakra-ui/react';
import inputStyle from './input';

const baseStyleField: SystemStyleObject = {
  appearance: 'none',
  paddingBottom: '1px',
  lineHeight: 'normal',
  _active: {
    'icon-wrapper': {
      color: 'yelloy',
    },
  },
};

const baseStyleIcon: SystemStyleObject = {
  width: '6',
  height: '100%',
  insetEnd: '2',
  position: 'relative',
  color: 'brand.red.light',
  fontSize: 'xl',
  _disabled: {
    color: '#ff0000',
    opacity: 0.5,
  },
};

const baseStyle: PartsStyleObject = {
  field: baseStyleField,
  icon: baseStyleIcon,
};

export default {
  parts: parts.keys,
  baseStyle,
  variants: inputStyle.variants,
  defaultProps: inputStyle.defaultProps,
};
